import { gql, useQuery } from '@apollo/client';

export const GET_PERMISSION_GROUP_BY_ID = gql`
  query getPermissionGroupById($permissionGroupId: String!) {
    getPermissionGroupById(permissionGroupId: $permissionGroupId) {
      name
      permissions {
        rule
        permission
      }
    }
  }
`;

export const useGetPermissionGroupById = (permissionGroupId: string) => {
  const { data, refetch } = useQuery(GET_PERMISSION_GROUP_BY_ID, {
    variables: {
      permissionGroupId,
    },
  });
  const { name, permissions = [] } = data?.getPermissionGroupById || {};

  return {
    name,
    permissions,
    refetch,
  };
};
